import SubNav from './SubNav'

class SubNavSetting extends React.Component {
  render () {
    let links
    let {user, location, isMobile, subscriptionExpired} = this.props

    if (user.is_owner) {
      if (isMobile) {
        links = [{
          href: '/settings/billing',
          label: 'Billing'
        }]
      } else {
        links = [
          {
            href: '/settings/accounts',
            label: 'Account'
          },
          {
            href: '/settings/billing',
            label: 'Billing'
          },
          {
            href: '/settings/public_profile',
            label: 'Public Profile'
          },
          {
            href: '/settings/receipt',
            label: 'Receipt'
          },
          {
            href: '/settings/checkout',
            label: 'Checkout'
          },
          {
            href: '/settings/email',
            label: 'Email Notification'
          }
        ]
      }
    } else if (user.is_manager) {
      links = [
        {
          href: '/settings/accounts',
          label: 'Account'
        },
        {
          href: '/settings/receipt',
          label: 'Receipt'
        }
      ]
    } else {
      if (isMobile) {
        links = []
      } else {
        links = [{
          href: '/settings/accounts',
          label: 'Account'
        }]
      }
    }
    return (<SubNav links={links} location={location} user={user} subscriptionExpired={subscriptionExpired} />)
  }
}

SubNavSetting.propTypes = {
  location: React.PropTypes.object
}

export default SubNavSetting



// WEBPACK FOOTER //
// ./app/components/SubNav/SubNavSetting.js